import React from 'react'
import * as R from 'remeda'

import { type FigureInfo } from '~/utils'

type CreateFigureInfo = (figureType: string) => FigureInfo

const CreateFigureInfoContext = React.createContext<CreateFigureInfo>(
  R.doNothing as unknown as CreateFigureInfo,
)

export type CreateFigureInfoProviderProps = React.PropsWithChildren<{
  createFigureInfo: CreateFigureInfo
}>

export const CreateFigureInfoProvider = ({
  children,
  createFigureInfo,
}: CreateFigureInfoProviderProps) => (
  <CreateFigureInfoContext.Provider value={createFigureInfo}>
    {children}
  </CreateFigureInfoContext.Provider>
)

export const useFigureInfo = (figureType: string) => {
  const createFigureInfo = React.useContext(CreateFigureInfoContext)

  return React.useMemo(
    () => createFigureInfo(figureType),
    [createFigureInfo, figureType],
  )
}
